import { initialAllergenState, IAllergenState } from '../state/allergen.state';
import { AllergenAction, EAllergenActions } from '../actions/allergen.action';


export function allergenReducers(state = initialAllergenState, action: AllergenAction): IAllergenState {
    switch (action.type) {

        case EAllergenActions.GetAllergenDetails: {
            return {
                ...state,
                getAllergenDetails: action.payload,
                getAllergenErrorMessage: null
            };
        }
        case EAllergenActions.SetAllergenSuccess: {
            const success = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getAllergenSuccessMessage: success,
                getAllergenErrorMessage: null
            };
        }
        case EAllergenActions.SetAllergenError: {
            const error = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getAllergenErrorMessage: error,
                getAllergenDetails: null
            };
        }
        case EAllergenActions.GetEditAllergenSuccess: {
           return {
                ...state,
                getEditAllergenSuccess: action.payload,
                getEditAllergenError: null
            };
        }
        case EAllergenActions.GetEditAllergenError: {
            return {
                 ...state,
                 getEditAllergenError: action.payload,
                 getEditAllergenSuccess: null
             };
         }
        default: {   
            return state;
          }
    }

}